import { api } from '@/shared/lib/api'
import { useQuery } from '@tanstack/react-query'

export const useSearchAutocomplete = (keyword: string, enabled: boolean = true) => {
    return useQuery({
        queryKey: ['search-autocomplete', keyword],
        queryFn: () => api.searchGlobal.autocomplete(keyword),
        enabled: enabled && !!keyword,
    })
}
